import { useEffect, useState } from "react";

const columns = [
  {
    title: "Id",
    dataIndex: "island_group_id",
    key: "island_group_id",
  },
  {
    title: "Island Group Name",
    dataIndex: "island_group_name",
    key: "island_group_name",
  },
  {
    title: "Alternative Name",
    dataIndex: "alternative_name",
    key: "alternative_name",
  },

  {
    title: "Date Created",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Last Modified Date",
    dataIndex: "updated_at",
    key: "updated_at",
  },
];

export default function useGetIslandGroupColumns() {
  const [tableColumns, setColumns] = useState(columns);

  useEffect(() => {
    setColumns(setColumns);
  }, []);

  return tableColumns;
}
